(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /**
   * Re-renders the bar through the Section Rendering API whenever the cart
   * drawer reports a new cart, so the tracker's sentence lives in Liquid only.
   */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      document.addEventListener('cart:updated', this.refresh);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.refresh);
    }

    refresh = async () => {
      const id = this.dataset.sectionId;

      try {
        const response = await fetch(
          window.Shopify.routes.root + '?sections=' + encodeURIComponent(id)
        );
        if (!response.ok) return;

        const data = await response.json();
        const html = new DOMParser().parseFromString(data[id], 'text/html');
        const fresh = html.querySelector('announcement-bar');
        if (!fresh) return;

        // No need to tell the header: it observes its own size, so a bar that
        // has just appeared or wrapped is re-measured without being asked.
        this.replaceWith(fresh);
      } catch (error) {
        // A stale bar is corrected by the next page load.
      }
    };
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * The cart drawer.
   *
   * Every mutation goes to Shopify's cart AJAX API and then re-renders this
   * section through the Section Rendering API, so the Liquid above stays the
   * single description of the drawer and nothing is templated twice.
   *
   * Opening is driven by the `data-open` attribute — the attribute-as-state
   * pattern the header already uses — so the CSS owns the animation entirely
   * and this file never touches a style.
   */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.cart-drawer__panel');

      this.addEventListener('click', this.onClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('cart:changed', this.onCartChanged);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('cart:changed', this.onCartChanged);
    }

    /**
     * The cart link stays a real link to /cart, so it still works with no
     * script and still opens in a new tab on a modified click. Only a plain
     * left click is taken over.
     */
    onDocumentClick = (event) => {
      const trigger = event.target.closest('[data-cart-toggle]');
      if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        this.open(trigger);
        return;
      }

      if (this.hasAttribute('data-open') && !this.contains(event.target)) this.close();
    };

    onClick = (event) => {
      if (event.target.closest('[data-cart-close]')) {
        this.close();
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      if (change) this.change(change.dataset.line, change.dataset.quantity);
    };

    onKeydown = (event) => {
      if (!this.hasAttribute('data-open')) return;

      if (event.key === 'Escape') {
        this.close();
        return;
      }

      if (event.key === 'Tab') this.trapFocus(event);
    };

    /**
     * Fired by anything that has already changed the cart — the PDP button.
     *
     * A failed re-render still opens the drawer, because the alternative is a
     * button that has visibly finished adding and nothing to show for it. The
     * contents are simply one request stale, and the next open corrects them.
     *
     * `cart:opened` closes the loop for whoever triggered this: the PDP button
     * holds its loading state until the drawer is actually on screen, rather
     * than finishing early and leaving a gap.
     */
    onCartChanged = async () => {
      try {
        await this.refresh();
      } catch (error) {
        // Deliberately swallowed — see above.
      }

      this.open();
      document.dispatchEvent(new CustomEvent('cart:opened'));
    };

    open(trigger) {
      // Remembered so focus can go back where it came from, which is the whole
      // reason a dialog is bearable with a keyboard.
      this.opener = trigger || document.activeElement;

      this.measure();
      this.setAttribute('data-open', '');
      this.setAttribute('aria-hidden', 'false');

      // After the frame that makes it visible: a `visibility` transition still
      // reports the start value at progress 0, so nothing inside is focusable
      // yet on the frame the attribute lands.
      requestAnimationFrame(() => {
        const target = this.querySelector('[data-cart-close]');
        if (target) target.focus();
      });
    }

    close() {
      this.removeAttribute('data-open');
      this.setAttribute('aria-hidden', 'true');
      if (this.opener && this.opener.isConnected) this.opener.focus();
      this.opener = null;
    }

    /**
     * The header is not sticky and has no height this file could know: the
     * announcement bar is merchant copy and the nav collapses by measurement.
     * So the offset is read off the header itself, at the moment it is needed.
     */
    measure() {
      const header = document.querySelector('.header');
      if (!header) return;

      /**
       * 8px, not Sitka's 36. Theirs is measured from a header that carries its
       * own bottom padding; ours sits tight to the nav, and 36 read as the
       * drawer having come loose from the cart icon it belongs to.
       */
      const bottom = header.getBoundingClientRect().bottom;
      this.style.setProperty('--cart-drawer-top', Math.max(0, bottom) + 8 + 'px');
    }

    async change(line, quantity) {
      this.setAttribute('data-busy', '');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
        });
        if (!response.ok) throw new Error(response.status);
        await this.refresh();
      } catch (error) {
        // A failed mutation must not leave a stale drawer claiming otherwise.
        window.location.assign(window.Shopify.routes.root + 'cart');
      } finally {
        this.removeAttribute('data-busy');
      }
    }

    /**
     * Re-render from the server. `?sections=` returns this section's markup for
     * the current cart, so there is no second copy of the template in here.
     */
    async refresh() {
      const id = this.dataset.sectionId;
      const url = window.Shopify.routes.root + '?sections=' + encodeURIComponent(id);

      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);

      const data = await response.json();
      const html = new DOMParser().parseFromString(data[id], 'text/html');
      const fresh = html.querySelector('cart-drawer');
      if (!fresh) throw new Error('no drawer in response');

      this.innerHTML = fresh.innerHTML;
      this.panel = this.querySelector('.cart-drawer__panel');
      this.updateCount();
    }

    /**
     * The header lives outside this section, so its count is updated directly
     * rather than by re-rendering a second section for two numbers.
     */
    async updateCount() {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!response.ok) return;

      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;

        // Only the badge disappears at zero. The label reads "Cart [0]" by
        // design, so hiding its number would leave an empty pair of brackets.
        if (node.hasAttribute('data-cart-hide-empty')) node.hidden = cart.item_count === 0;
      });

      // `cart:changed` means "the cart changed, show it" and opens the drawer.
      // This one is for everything else that mirrors the cart — the
      // announcement bar's shipping tracker — and says only that it is new.
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    }

    /** Keeps Tab inside the dialog while it is modal. */
    trapFocus(event) {
      const focusable = this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Load More, copied from Sitka's collection.
   *
   * Their control is a real <a href="?page=2">, and so is ours — without
   * JavaScript it is ordinary pagination and every page stays a crawlable URL.
   * All this adds is fetching that page and appending its cards instead of
   * navigating, then advancing the count, the bar and the button's own href.
   *
   * The next URL always comes from the page just fetched rather than being
   * computed here, so filters and sort carry through for free: `paginate`
   * builds its links from the request's own query string.
   */
  class CollectionMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-more-button]');
      this.count = this.querySelector('[data-more-count]');
      this.fill = this.querySelector('[data-more-fill]');
      this.grid = document.querySelector('.collection__grid');
      if (!this.button || !this.grid) return;

      this.total = Number(this.dataset.total) || 0;
      this.shown = Number(this.dataset.shown) || 0;
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      // Leave modified clicks alone — opening page 2 in a new tab is a
      // perfectly reasonable thing to want.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      this.load();
    };

    async load() {
      const url = this.button.getAttribute('href');
      if (!url) return;

      this.setAttribute('data-loading', '');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = doc.querySelectorAll('.collection__grid > *');
        if (!cards.length) throw new Error('no cards');

        this.grid.append(...cards);
        this.shown += cards.length;

        // The fetched page knows where it goes next; we do not.
        const next = doc.querySelector('[data-more-button]');
        if (next) {
          this.button.setAttribute('href', next.getAttribute('href'));
          this.render();
        } else {
          this.remove();
        }
      } catch (error) {
        // Fall back to being the link it already is.
        window.location.assign(url);
      } finally {
        this.removeAttribute('data-loading');
      }
    }

    render() {
      const remaining = Math.max(0, this.total - this.shown);

      if (this.count) {
        this.count.textContent = this.dataset.labelViewing
          .replace('[shown]', this.shown)
          .replace('[total]', this.total);
      }

      if (this.fill) {
        this.fill.style.width = (this.shown / this.total) * 100 + '%';
      }

      this.button.textContent = this.dataset.labelMore.replace('[count]', remaining);
    }
  }

  customElements.define('collection-more', CollectionMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-menu-toggle]');
      if (!this.button) return;

      this.button.addEventListener('click', this.toggle);
      this.addEventListener('click', this.onSubmenuClick);
      document.addEventListener('keydown', this.onKeydown);

      // Delegated: pointerover bubbles, so one listener covers every item and
      // survives the menu being re-rendered by the section editor.
      this.addEventListener('pointerover', this.onPointerOver);

      this.search = this.querySelector('[data-search-panel]');
      this.searchInput = this.querySelector('[data-search-input]');
      if (this.search && this.searchInput) {
        this.addEventListener('input', this.onSearchInput);
        this.searchDebounce = null;
        this.searchSeq = 0;
      }

      this.scrim = this.querySelector('[data-scrim]');
      if (this.scrim) {
        this.scrim.addEventListener('pointerenter', this.closeDropdown);
        this.scrim.addEventListener('click', this.onScrimClick);
      }

      this.nav = this.querySelector('.header__menu');
      this.list = this.querySelector('.header__menu-list');
      if (!this.nav || !this.list) return;

      this.fit();
      this.resizeObserver = new ResizeObserver(this.fit);
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.toggle);
      this.removeEventListener('click', this.onSubmenuClick);
      this.removeEventListener('pointerover', this.onPointerOver);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.scrim) {
        this.scrim.removeEventListener('pointerenter', this.closeDropdown);
        this.scrim.removeEventListener('click', this.onScrimClick);
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    /**
     * Decide whether the nav row fits beside the centred logo.
     *
     * `measuring` lays the row out inline so its true width can be read, then
     * the final state replaces it in the same frame — the browser never paints
     * the intermediate step. Guarding on width means height-only resizes (an
     * opening panel, say) can't feed the observer back into itself.
     */
    fit = () => {
      const width = this.clientWidth;
      if (width === this.lastWidth) return;
      this.lastWidth = width;

      // Below the two-column breakpoint the burger is the design, not a
      // fallback, so there is nothing to measure.
      if (window.innerWidth < 990) {
        this.dataset.nav = 'collapsed';
        return;
      }

      this.dataset.nav = 'measuring';
      const fits = this.list.scrollWidth <= this.nav.clientWidth;
      this.dataset.nav = fits ? 'inline' : 'collapsed';

      // A panel left open would otherwise linger behind the now-inline row.
      if (fits) this.open = false;
    };

    /**
     * The collapsed panel's accordion. Inline, the button is display:none and
     * the dropdown is CSS-only, so this never runs there.
     *
     * Delegated from the host element, which is also why it has to ignore the
     * burger's own clicks — they bubble through here too.
     */
    onSubmenuClick = (event) => {
      /**
       * The toggle is a real link to /search, so only a plain left click is
       * ours to take — a modified click or a middle click should still open the
       * page, the same bargain the cart makes.
       */
      const searchToggle = event.target.closest('[data-search-toggle]');
      if (searchToggle) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        this.searchOpen = !this.searchOpen;
        return;
      }

      if (event.target.closest('[data-search-close]')) {
        this.searchOpen = false;
        this.querySelector('[data-search-toggle]')?.focus();
        return;
      }

      if (event.target.closest('[data-search-clear]')) {
        this.searchInput.value = '';
        this.searchInput.focus();
        this.onSearchInput();
        return;
      }

      if (event.target.closest('[data-menu-close]')) {
        this.open = false;
        this.button.focus();
        return;
      }

      if (event.target.closest('[data-menu-back]')) {
        this.goToLevel(null, 'back');
        return;
      }

      const toggle = event.target.closest('[data-submenu-toggle]');
      if (!toggle) return;

      this.goToLevel(this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`), 'forward');
    };

    /**
     * Move the drawer to a level, or back to the root with `null`.
     *
     * The entrance is a CSS animation, and an animation only runs once per
     * element unless it is taken off and put back on. Removing the attribute,
     * reading `offsetWidth` to force the style change to land, then setting it
     * again is what restarts it — otherwise every level after the first would
     * simply appear.
     *
     * @param {HTMLElement | null} level - the submenu list to show.
     * @param {'forward' | 'back'} direction - which way the rows come in from.
     */
    goToLevel = (level, direction) => {
      for (const open of this.querySelectorAll('.header__submenu[data-active]')) {
        delete open.dataset.active;
      }

      const menu = this.querySelector('.header__menu');
      const back = this.querySelector('[data-menu-back]');

      if (level) {
        level.dataset.active = '';
        menu.dataset.path = level.id;
      } else {
        delete menu.dataset.path;
      }

      menu.dataset.direction = direction;
      back.hidden = !level;

      // Names the level being returned to. One level down that is the root, so
      // the label stays whatever the template rendered.
      const label = back.querySelector('[data-back-label]');
      const parent = level?.parentElement.closest('.header__submenu');
      if (parent) label.textContent = parent.dataset.title;
      else label.textContent = label.dataset.root ?? label.textContent;

      delete menu.dataset.animating;
      void menu.offsetWidth;
      menu.dataset.animating = '';

      menu.scrollTop = 0;
    };

    /**
     * The inline dropdown's open state, following Sitka: exactly one panel open
     * at a time, opening the instant the pointer reaches a parent item, and —
     * the part a `:hover` selector can't do — closing when the pointer reaches a
     * top-level item that has no children of its own.
     *
     * Only inline. Collapsed, the panel is an accordion driven by clicks on the
     * toggle button, and `data-nav` is what tells the two apart.
     */
    onPointerOver = (event) => {
      if (this.dataset.nav !== 'inline') return;

      const item = event.target.closest('.header__menu-item');
      if (!item || !this.contains(item)) return;

      this.openDropdown(item.querySelector('.header__submenu') ? item : null);
    };

    /**
     * @param {HTMLElement | null} item - the item to open, or null to close all.
     */
    openDropdown = (item) => {
      for (const open of this.querySelectorAll('.header__menu-item[data-open]')) {
        if (open !== item) delete open.dataset.open;
      }
      if (item) item.dataset.open = '';
    };

    closeDropdown = () => this.openDropdown(null);

    get searchOpen() {
      return this.search ? !this.search.hidden : false;
    }

    set searchOpen(value) {
      if (!this.search) return;

      this.search.hidden = !value;
      this.closeDropdown();

      if (value) {
        // Autofocus on open: the panel is useless until you can type.
        this.searchInput.focus();
        this.searchInput.select();

        // On /search the field opens prefilled with the terms, so the two
        // controls that follow it have to be caught up without waiting for a
        // keystroke that may never come. No prediction — the page behind is
        // already the full results for this query.
        const query = this.searchInput.value.trim();
        for (const el of this.querySelectorAll('[data-search-clear], [data-search-footer]')) {
          el.hidden = query.length === 0;
        }

        // A drawer reopens at the top of its list, not where it was left.
        const body = this.querySelector('.header__search-body');
        if (body) body.scrollTop = 0;
      }
    }

    /**
     * Shopify's predictive endpoint, which is what stands in for SearchSpring
     * here. Debounced because it fires per keystroke, and sequence-numbered
     * because responses can land out of order — a slow request for "hol" must
     * not overwrite the results for "holster" typed after it.
     */
    onSearchInput = () => {
      const query = this.searchInput.value.trim();
      const clear = this.querySelector('[data-search-clear]');
      if (clear) clear.hidden = query.length === 0;

      // Both of these follow the field, not the results, so they are set here
      // rather than waiting out the debounce with the prediction: the way to the
      // full results page is valid from the first keystroke, and a footer that
      // arrived 200ms after the text did would read as a stutter.
      const footer = this.querySelector('[data-search-footer]');
      if (footer) footer.hidden = query.length === 0;

      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => this.predict(query), 200);
    };

    async predict(query) {
      const results = this.querySelector('[data-search-results]');
      const suggested = this.querySelector('[data-search-suggested]');
      const groupsEl = this.querySelector('[data-search-groups]');
      const empty = this.querySelector('[data-search-empty]');
      const footer = this.querySelector('[data-search-footer]');
      const status = this.querySelector('[data-search-status]');
      if (!results || !groupsEl) return;

      // Nothing to see all of until something has been typed, so the footer
      // follows the field rather than the results — it is the way to the full
      // page, which is worth offering even while the prediction is still out.
      if (footer) footer.hidden = query.length === 0;

      // Below two characters the endpoint mostly returns noise, so the panel
      // falls back to its resting state rather than flickering a short list.
      //
      // The empty message is cleared here as well as hidden with its container:
      // deleting a query down to nothing must not leave "No results for" the
      // thing that is no longer being searched for sitting in the drawer, and
      // `results.hidden` alone would only stop you seeing it, not fix it.
      if (query.length < 2) {
        results.hidden = true;
        if (suggested) suggested.hidden = false;
        if (empty) {
          empty.hidden = true;
          empty.textContent = '';
        }
        groupsEl.replaceChildren();
        return;
      }

      const seq = ++this.searchSeq;

      /**
       * `variants.sku` is the whole reason this request names its fields.
       *
       * The predictive endpoint searches `title,product_type,variants.title,vendor`
       * by default and does NOT look at SKUs, so a part number typed into the
       * drawer returned nothing while the same query on /search found the product
       * — the full search page does index SKUs. Naming the fields is the only way
       * to add one, and naming any means naming them all, so the four defaults
       * are repeated here rather than replaced.
       *
       * Measured against the live catalogue before committing to it: `7130-1`,
       * `7130-2-CK` and `7720-G3-H` all go from 0 products to the right one, the
       * bare prefix `7130` returns both products in that family, and ten text
       * queries — "holster", "range bag", "chest holster", "sling pack" and the
       * rest — return results identical to the default field set. Adding the SKU
       * costs nothing on ordinary searches.
       */
      const fields = 'title,product_type,variants.title,vendor,variants.sku';

      try {
        const url =
          `${this.dataset.searchUrl || '/search'}/suggest.json?q=${encodeURIComponent(query)}` +
          '&resources[type]=product,collection,article&resources[limit]=6' +
          `&resources[options][fields]=${fields}`;

        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const data = await response.json();
        if (seq !== this.searchSeq) return; // a later keystroke already won

        const found = data?.resources?.results ?? {};

        // Products first: they are what a search for a product name is for, and
        // the only group with a price to show. A group the endpoint returned
        // nothing for is not rendered at all.
        const groups = [
          ['products', found.products],
          ['collections', found.collections],
          ['articles', found.articles],
        ].filter(([, hits]) => hits?.length > 0);

        const count = groups.reduce((total, [, hits]) => total + hits.length, 0);

        groupsEl.replaceChildren(...groups.map(([type, hits]) => this.hitGroup(type, hits)));
        results.hidden = false;

        // The promoted terms stay up alongside a result set of nothing, because
        // then they are the only thing left to act on.
        if (suggested) suggested.hidden = count > 0;

        if (empty) {
          empty.hidden = count > 0;
          const template = this.dataset.labelEmpty ?? '';
          empty.textContent = template ? template.replace('%s', query) : '';
        }

        if (status) status.textContent = `${count}`;
      } catch {
        // The form still submits, so a failed prediction costs the list only.
        if (seq !== this.searchSeq) return;
        results.hidden = true;
        if (suggested) suggested.hidden = false;
      }
    }

    /**
     * One captioned group of hits.
     *
     * @param {'products' | 'collections' | 'articles'} type - the resource type.
     * @param {object[]} hits - the endpoint's rows for it.
     */
    hitGroup(type, hits) {
      const section = document.createElement('section');
      section.className = 'header__search-group';

      const caption = document.createElement('h2');
      caption.className = 'header__search-caption';
      caption.textContent = this.dataset[`label${type[0].toUpperCase()}${type.slice(1)}`] ?? type;

      const list = document.createElement('ul');
      list.className = 'header__search-list';
      list.setAttribute('role', 'list');
      list.append(...hits.map((hit) => this.hitRow(hit)));

      section.append(caption, list);
      return section;
    }

    hitRow(hit) {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'header__search-hit';
      link.href = hit.url;

      // Collections come back with a `featured_image` object whose url is null
      // rather than no object at all, so the fallback has to be a truthiness
      // check and not just optional chaining.
      const image = hit.featured_image?.url || hit.image;
      if (image) {
        const img = document.createElement('img');
        img.src = image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 56;
        img.height = 56;
        link.appendChild(img);
      } else {
        // An empty box rather than no box: without it, a row with no image
        // starts its title 72px left of the rows above and below it.
        const box = document.createElement('span');
        box.className = 'header__search-hit-thumb';
        link.appendChild(box);
      }

      const text = document.createElement('span');
      text.className = 'header__search-hit-text';

      const title = document.createElement('span');
      title.className = 'header__search-hit-title';
      title.textContent = hit.title;
      text.appendChild(title);

      const price = this.hitPrice(hit);
      if (price) text.appendChild(price);

      link.appendChild(text);
      item.appendChild(link);
      return item;
    }

    /**
     * The price line, for the rows that have one. Collections and articles do
     * not, and neither does a product the endpoint gave no price for.
     *
     * `price` arrives as a decimal string in the shop's currency — "87.82", no
     * symbol — so the formatting is ours to do. `Intl` rather than a hand-rolled
     * pass over `shop.money_format`, which has a dozen placeholder spellings and
     * would need all of them handled to be worth anything.
     *
     * @param {object} hit - a row from the endpoint.
     * @returns {HTMLElement | null}
     */
    hitPrice(hit) {
      if (hit.price == null) return null;

      const money = (value) => {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return null;

        this.money ??= new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.dataset.searchCurrency || 'USD',
        });

        return this.money.format(amount);
      };

      const current = money(hit.price);
      if (!current) return null;

      const line = document.createElement('span');
      line.className = 'header__search-hit-price';

      // A variant-priced product is a range, and the low end of it is the only
      // honest single number to show — the same "From" the collection cards use.
      const ranged = hit.price_min !== hit.price_max;

      // Struck first, then what you pay. Only on a single price: a range has no
      // one compare-at to strike, and showing the range's own top as the old
      // price would be a markdown the product does not have.
      const compare = ranged ? null : money(hit.compare_at_price_max);
      if (compare && Number(hit.compare_at_price_max) > Number(hit.price)) {
        const was = document.createElement('s');
        was.className = 'header__search-hit-compare';
        was.textContent = compare;
        line.appendChild(was);
      }

      const now = document.createElement('span');
      const template = this.dataset.labelFrom ?? '';
      now.textContent = ranged && template ? template.replace('%s', current) : current;
      line.appendChild(now);

      return line;
    }

    /* The same surface backs both, so which one it dismisses depends on which
       is actually open. */
    onScrimClick = () => {
      if (this.searchOpen) this.searchOpen = false;
      else if (this.open) this.open = false;
      else this.closeDropdown();
    };

    /* A closed drawer reopens at the root, not wherever it was left. */
    closeSubmenus = () => this.goToLevel(null, 'forward');

    /**
     * Dismiss an inline dropdown without moving the pointer or focus, which is
     * what WCAG 1.4.13 asks of hover-triggered content. `:focus-within` is a
     * live CSS state that script cannot unset, so the only way to override it
     * is to mark the item — and then unmark it once focus genuinely leaves, or
     * the item would stay dead until the next page load.
     */
    dismiss = (item) => {
      item.dataset.dismissed = '';

      const restore = (event) => {
        // focusout also fires when focus moves between the item's own children.
        if (event && event.relatedTarget && item.contains(event.relatedTarget)) return;

        delete item.dataset.dismissed;
        item.removeEventListener('mouseleave', restore);
        item.removeEventListener('focusout', restore);
      };

      item.addEventListener('mouseleave', restore);
      item.addEventListener('focusout', restore);
    };

    get open() {
      return this.button.getAttribute('aria-expanded') === 'true';
    }

    set open(value) {
      // CSS reads this attribute directly, so setting it is the whole toggle.
      this.button.setAttribute('aria-expanded', String(value));
      // A closed panel should reopen at the top level, not wherever it was left.
      if (!value) this.closeSubmenus();
    }

    toggle = () => {
      this.open = !this.open;
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;

      // Search sits above everything else, so it is the first thing Escape
      // should take back — and focus returns to the control that opened it.
      if (this.searchOpen) {
        this.searchOpen = false;
        this.querySelector('[data-search-toggle]')?.focus();
        return;
      }

      if (this.open) {
        this.open = false;
        // Send focus back to the control that opened the panel.
        this.button.focus();
        return;
      }

      // Otherwise the nav is inline. Clearing the open state closes a panel the
      // pointer opened, and it stays closed because pointerover won't fire again
      // until the pointer actually moves. One held open by :focus-within is a
      // CSS state this can't unset, so that still needs the marker.
      this.closeDropdown();

      const item = this.querySelector('.header__menu-item:focus-within');
      if (item) this.dismiss(item);
    };
  }

  customElements.define('header-menu', HeaderMenu);

  /**
   * Sitka's header behaviour, reproduced from their own numbers.
   *
   * Scrolling down slides the whole header up and off; scrolling back up brings
   * it down again, under a spring, with a soft shadow that deepens with scroll
   * depth. So it is sticky only for part of the scroll — it does not sit at the
   * top of the page forever eating vertical space. The point of the
   * up-threshold is that it shouldn't come back for the small reverse jitter at
   * the end of a trackpad fling — it should take a deliberate scroll up.
   *
   * The constants are theirs: they drive it with framer-motion's
   * `useSpring({ bounce: 0, visualDuration: 0.6 })`, which is a critically
   * damped spring — no overshoot, ~96% of the way there in 0.6s. That's an
   * undamped frequency of 2π / (0.6 × 1.2) ≈ 8.7 rad/s, which is all the
   * integrator below needs.
   */
  class StickyHeader extends HTMLElement {
    /* Slack below the fold before the bar is allowed to retract at all. */
    static SETTLE_ZONE = 32;
    /* Cumulative upward scroll that brings it back down. */
    static UP_TRIGGER = 80;
    /* Scroll depth at which the shadow reaches full strength. */
    static SHADOW_RANGE = 300;
    static SHADOW_ALPHA = 0.1;
    /* Natural frequency of the spring, in rad/s. */
    static OMEGA = 8.7;
    /* How far you can scroll before a transparent header goes solid. */
    static TRANSPARENT_UNTIL = 40;

    connectedCallback() {
      this.header = this.querySelector('.header');
      if (!this.header) return;

      /**
       * Only pages that put something behind the header ask for this, and they
       * say so by marking that section. Read once: a homepage either has a
       * transparent hero or it does not, and it will not gain one mid-session.
       */
      this.transparent = document.querySelector('[data-transparent-header]') != null;
      if (this.transparent) this.setAttribute('data-transparent', '');

      this.target = 0; // where the spring is heading
      this.position = 0; // where it currently is
      this.velocity = 0;
      this.upDistance = 0; // upward scroll banked since the last downward move
      this.travel = 0; // how far it slides to be fully gone: its own height
      this.lastScroll = window.scrollY;
      this.frame = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.measure();
      this.paint();

      window.addEventListener('scroll', this.onScroll, { passive: true });

      // Safe to observe itself: the two things paint() writes, `top` and the
      // shadow, are both outside the border box, so this can't feed back.
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }

    /**
     * The header travels its own full height, so it ends up completely off
     * screen rather than leaving the nav behind. Measured rather than
     * hard-coded: the announcement bar's text wraps at narrow widths, and the
     * group can gain or lose a row without this needing to know.
     */
    measure = () => {
      const height = this.offsetHeight;
      if (height === this.travel) return;

      this.travel = height;

      /* No --header-height exists in this theme, and a hero that sits under the
         header needs one to know how far to reach up. Published here because
         this already re-measures on resize. */
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
      /* The announcement bar is whatever is left of the group once the header
         is taken out of it. A full-viewport hero starts below the bar and runs
         under the nav, so the bar is the only thing it has to subtract — and
         its height is merchant copy, which can wrap to a second row. */
      document.documentElement.style.setProperty(
        '--announcement-height',
        `${height - this.header.offsetHeight}px`
      );
      // A header that's already hidden stays hidden at its new height.
      if (this.target < 0) this.target = -height;
      this.position = Math.max(this.position, -height);
      this.paint();
      this.animate();
    };

    onScroll = () => {
      const scroll = window.scrollY;
      const delta = scroll - this.lastScroll;
      this.lastScroll = scroll;

      if (scroll <= this.travel + StickyHeader.SETTLE_ZONE) {
        // Near the top of the page the header is always fully down.
        this.upDistance = 0;
        this.target = 0;
      } else if (delta > 0) {
        this.upDistance = 0;
        this.target = -this.travel;
      } else if (delta < 0) {
        this.upDistance += -delta;
        if (this.upDistance >= StickyHeader.UP_TRIGGER) this.target = 0;
      }

      // Transparent only while the hero is still effectively unscrolled. The
      // threshold is small on purpose: the bar should commit to solid as soon
      // as the page has clearly moved, not fade out gradually behind the copy.
      if (this.transparent) {
        this.toggleAttribute('data-transparent', scroll < StickyHeader.TRANSPARENT_UNTIL);
      }

      // The shadow tracks scroll depth, so it needs repainting even in the
      // common case where the spring is already at rest.
      this.paint();
      this.animate();
    };

    paint = () => {
      this.style.top = `${this.position}px`;

      /**
       * The shadow is the header reading as raised above the page, so it fades
       * in with scroll depth — and it's suppressed once the header is fully off
       * screen, where there's nothing left for it to separate from anything.
       */
      const retracted = this.travel > 0 && this.position < -(this.travel - 2);
      const depth = window.scrollY / StickyHeader.SHADOW_RANGE;
      const ramp = retracted ? 0 : Math.min(Math.max(depth, 0), 1);
      this.style.boxShadow = `0 4px 16px 0 rgba(0, 0, 0, ${(StickyHeader.SHADOW_ALPHA * ramp).toFixed(4)})`;
    };

    animate = () => {
      if (this.reduceMotion.matches) {
        this.position = this.target;
        this.velocity = 0;
        this.paint();
        return;
      }
      if (this.frame !== null) return;
      this.frameTime = performance.now();
      this.frame = requestAnimationFrame(this.step);
    };

    /**
     * A critically damped spring, integrated semi-implicitly. `dt` is capped so
     * that a long frame — a background tab waking up, a slow paint — can't hand
     * the integrator a step big enough to make it unstable.
     */
    step = (now) => {
      const dt = Math.min((now - this.frameTime) / 1000, 1 / 30);
      this.frameTime = now;

      const { OMEGA } = StickyHeader;
      const displacement = this.position - this.target;
      this.velocity += (-2 * OMEGA * this.velocity - OMEGA * OMEGA * displacement) * dt;
      this.position += this.velocity * dt;

      // Snap and stop once the remaining motion is under a subpixel.
      const settled = Math.abs(this.position - this.target) < 0.05 && Math.abs(this.velocity) < 0.5;
      if (settled) {
        this.position = this.target;
        this.velocity = 0;
      }

      this.paint();
      this.frame = settled ? null : requestAnimationFrame(this.step);
    };
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Decides whether the hero video is downloaded at all, and only then attaches
   * its source. Nothing here is required for the hero to work — with no script
   * the poster image stands on its own, which is the state this is designed to
   * fall back to rather than an exception it has to handle.
   */
  class HeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || !this.dataset.src) return;

      // Reduced motion means no autoplaying loop, and no reason to spend the
      // bytes fetching one.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Desktop-only is a bandwidth decision, so it has to be made before the
      // src is set — a hidden video with a src still downloads.
      if (this.hasAttribute('data-desktop-only') && window.innerWidth < 750) return;

      // `playing` rather than `canplay`: it fires when frames are actually
      // being presented, so the fade cannot reveal an empty box.
      this.video.addEventListener('playing', this.onPlaying, { once: true });

      this.video.src = this.dataset.src;

      /**
       * Autoplay is refused in more cases than muted-and-inline covers — Low
       * Power Mode on iOS, and data saver on Android among them. The rejection
       * is caught so the poster simply stays, rather than an unhandled promise
       * landing in the console on a page that is otherwise fine.
       */
      const started = this.video.play();
      if (started) started.catch(() => this.removeAttribute('data-playing'));
    }

    disconnectedCallback() {
      if (this.video) this.video.removeEventListener('playing', this.onPlaying);
    }

    onPlaying = () => this.setAttribute('data-playing', '');
  }

  if (!customElements.get('hero-video')) customElements.define('hero-video', HeroVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-features"]) return;
  try {
    
  class KeyFeatures extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.counter = this.querySelector('[data-count-current]');
      this.active = 0;

      if (!this.rail || !this.counter || this.items.length < 2) return;

      // An IntersectionObserver rather than a scroll listener, so dragging does
      // no per-frame work on the main thread.
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const index = this.items.indexOf(entry.target);
            if (index < 0 || index === this.active) continue;
            this.active = index;
            this.counter.textContent = index + 1;
            this.warm(index);
          }
        },
        { root: this.rail, threshold: 0.6 }
      );

      for (const item of this.items) this.observer.observe(item);
    }

    /**
     * Start the next cards downloading before the thumb reaches them.
     *
     * Same fix as the PDP gallery, for the same reason: every card ships
     * `loading="lazy"`, which is right on first paint and wrong once someone is
     * swiping, because the fetch only begins as the card approaches. Flipping
     * an unstarted image to eager begins the request immediately.
     */
    warm(from) {
      for (let i = from + 1; i <= from + 2; i += 1) {
        const img = this.items[i]?.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('key-features', KeyFeatures);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Arrow control for the image rail.
   *
   * Ported from product-row rather than rewritten, including the reason it
   * looks like this: scrolling by a stride (card + gap) lands between two snap
   * points, `scroll-snap-type: mandatory` then pulls the row on by its own
   * inset, and every press advances slightly more than one card until the row
   * is out of step with itself. So the target is a real snap position, read
   * off the children, with the scroll-padding subtracted — the snapport is the
   * scrollport less scroll-padding, not less padding.
   */
  class ProductImageCarousel extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-scroller]');
      this.prev = this.querySelector('[data-scroll-prev]');
      this.next = this.querySelector('[data-scroll-next]');
      if (!this.rail || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));

      /* Passive: this only reads scroll position to set a disabled state, so
         it must never be able to block the scroll it is watching. */
      this.rail.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    get positions() {
      const railLeft = this.rail.getBoundingClientRect().left;
      const pad = parseFloat(getComputedStyle(this.rail).scrollPaddingInlineStart) || 0;
      return [...this.rail.children].map((item) =>
        Math.round(this.rail.scrollLeft + item.getBoundingClientRect().left - railLeft - pad)
      );
    }

    step(direction) {
      const current = this.rail.scrollLeft;
      const positions = this.positions;
      const target =
        direction > 0
          ? positions.find((p) => p > current + 1)
          : [...positions].reverse().find((p) => p < current - 1);

      /* Past the last card there is still the trailing inset to reveal, so an
         end press runs to the true maximum rather than doing nothing. */
      const fallback = direction > 0 ? this.rail.scrollWidth : 0;
      this.rail.scrollTo({ left: target === undefined ? fallback : target });
    }

    sync() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      /* 1px of slack: sub-pixel widths mean scrollLeft rarely lands exactly on
         0 or on max, and a strict compare leaves an arrow live at the end. */
      this.prev.disabled = this.rail.scrollLeft <= 1;
      this.next.disabled = this.rail.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('product-image-carousel')) {
    customElements.define('product-image-carousel', ProductImageCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /**
   * Fetches the section through the Section Rendering API and swaps its own
   * contents in.
   *
   * Deferred until the row is near the viewport. `rootMargin` buys 400px of
   * warning, which at a normal scroll speed is enough for the request to land
   * before the row is looked at, without spending it on visitors who stop at
   * the buy button.
   *
   * Failure is silent by design: the element simply stays hidden. There is no
   * error state worth showing for a row of suggestions, and a visible empty
   * band would be worse than the absence.
   */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // The fetched copy of this section contains this element too. It arrives
      // already populated, so it must not start the cycle again.
      if (!this.dataset.url || this.dataset.loaded) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '400px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async load() {
      this.dataset.loaded = 'true';

      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('product-recommendations');

        // No recommendations for this product is the ordinary case for a new or
        // low-traffic item, not a failure — Shopify returns an empty section.
        if (!incoming || incoming.innerHTML.trim() === '') return;

        this.innerHTML = incoming.innerHTML;

        // Only now does the row earn its padding — see the stylesheet.
        this.dataset.filled = 'true';
      } catch (error) {
        // Network failure. Nothing to show, nothing to say.
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  /**
   * Review pagination.
   *
   * The section renders the first five reviews from Judge.me's metafield
   * snapshot, which is all that metafield holds. Pages 2+ come from the same
   * endpoint their own widget calls:
   *
   *   api.judge.me/reviews/reviews_for_widget
   *     ?shop_domain=<shop>&platform=shopify&product_id=<id>&page=<n>
   *
   * It needs no API token, sends `access-control-allow-origin: *`, and returns
   * { html, total_count, page }. That lets the reviews be paged without loading
   * Judge.me's widget, script or stylesheet — the response is parsed and
   * re-rendered into this section's own markup.
   *
   * ⚠️ It is an undocumented widget endpoint, so it can change without notice.
   * Everything here is built to fail quietly if it does: the first page is
   * server-rendered, so a broken fetch costs the pagination and nothing else.
   *
   * The same route fixes the products Judge.me never wrote a snapshot for —
   * `data-fetch-first` sends this to get page one too, so a product with 509
   * reviews and no snapshot still shows reviews rather than a bare score.
   */
  class ProductReviews extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-reviews-list]');
      this.nav = this.querySelector('[data-reviews-pagination]');
      this.caret = this.querySelector('[data-caret]');
      if (!this.list || !this.nav) return;

      this.total = Number(this.dataset.total) || 0;
      this.perPage = Number(this.dataset.perPage) || 5;
      this.pages = Math.ceil(this.total / this.perPage);
      this.page = 1;

      /**
       * ⚠️ BOTH of these run BEFORE the pagination guard below.
       *
       * A product whose snapshot Judge.me never wrote has an empty list, and
       * filling it has nothing to do with whether there are enough reviews to
       * page through. Putting the fetch after the guard meant any such product
       * with five reviews or fewer rendered a reviews section with **no
       * reviews in it** — `pages` is `ceil(2 / 5)` = 1, so the guard returned
       * first. Padded Pistol Case: two real reviews, none of them displayed.
       * Warden only ever worked here because 510 reviews clears the guard.
       */
      if (this.hasAttribute('data-fetch-first')) {
        this.fillHistogram();
        this.go(1);
      }

      if (this.pages < 2) return;

      this.nav.addEventListener('click', this.onClick);
      this.render();
    }

    /**
     * Rebuild the star breakdown for products Judge.me never wrote a snapshot
     * for. Only the snapshot carries a histogram; the review endpoint returns a
     * page of markup and a total, and no amount of paging it is affordable when
     * a product has 510 reviews.
     *
     * `filter_rating` is the way out: the endpoint honours it and still reports
     * `total_count` for the filtered set, so one request per star gives the
     * whole distribution — five requests, whatever the review count. The rows
     * are only shown if they add up to the total we already display, since a
     * breakdown that disagrees with the headline count is worse than none.
     *
     * Undocumented, like the rest of this endpoint, so every failure path just
     * leaves the bars hidden and the score standing on its own.
     */
    async fillHistogram() {
      const list = this.querySelector('[data-histogram]');
      if (!list || list.children.length || this.total < 1) return;

      const stars = [5, 4, 3, 2, 1];

      try {
        const counts = await Promise.all(stars.map((star) => this.countFor(star)));
        if (counts.some((count) => count === null)) return;

        const sum = counts.reduce((a, b) => a + b, 0);
        if (sum !== this.total) return;

        const template = this.dataset.labelHistogram || '';
        list.replaceChildren(
          ...stars.map((star, index) => {
            const count = counts[index];
            const row = document.createElement('li');
            row.className = 'reviews__histogram-row';

            const label = document.createElement('span');
            label.className = 'reviews__histogram-star';
            label.textContent = star;

            const track = document.createElement('span');
            track.className = 'reviews__histogram-track';
            const fill = document.createElement('span');
            fill.className = 'reviews__histogram-fill';
            fill.style.width = `${(count / sum) * 100}%`;
            track.appendChild(fill);

            const value = document.createElement('span');
            value.className = 'reviews__histogram-count';
            value.textContent = count;

            // Screen readers cannot infer anything from a bar's width.
            const described = document.createElement('span');
            described.className = 'visually-hidden';
            described.textContent = template
              .replace('RATING_', star)
              .replace('COUNT_', count);

            row.append(label, track, value, described);
            return row;
          })
        );

        list.hidden = false;
      } catch {
        /* leave the bars hidden */
      }
    }

    /** @returns {Promise<number | null>} how many reviews gave this many stars. */
    async countFor(star) {
      try {
        const url =
          'https://api.judge.me/reviews/reviews_for_widget?shop_domain=' +
          encodeURIComponent(this.dataset.shop) +
          '&platform=shopify&product_id=' +
          encodeURIComponent(this.dataset.productId) +
          '&page=1&filter_rating=' + star;

        const response = await fetch(url);
        if (!response.ok) return null;

        const data = await response.json();
        return typeof data.total_count === 'number' ? data.total_count : null;
      } catch {
        return null;
      }
    }

    disconnectedCallback() {
      if (this.nav) this.nav.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const button = event.target.closest('[data-page]');
      if (!button || button.disabled) return;
      this.go(Number(button.dataset.page), true);
    };

    async go(page, fromClick) {
      this.setAttribute('data-loading', '');

      try {
        const url =
          'https://api.judge.me/reviews/reviews_for_widget?shop_domain=' +
          encodeURIComponent(this.dataset.shop) +
          '&platform=shopify&product_id=' +
          encodeURIComponent(this.dataset.productId) +
          '&page=' + page;

        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const data = await response.json();
        const items = this.parse(data.html);
        if (!items.length) throw new Error('no reviews in response');

        this.list.replaceChildren(...items);
        this.page = page;

        // Only when there is actually more than one page. This now also runs
        // for the first-page fetch on a product with a handful of reviews,
        // where drawing a one-page pager would be a control that says nothing.
        if (this.pages > 1) this.render();

        // The server-rendered "showing 5 of 95" is superseded by real paging.
        const count = this.querySelector('[data-reviews-count]');
        if (count) count.hidden = true;

        /**
         * Only ever after a real click.
         *
         * This also runs for the automatic `data-fetch-first` load, and
         * scrolling there yanked the visitor from the top of a freshly opened
         * PDP straight down to the reviews. Paging on request should move you;
         * a background fetch never should.
         */
        if (fromClick) this.list.scrollIntoView({ block: 'nearest' });
      } catch (error) {
        this.fail();
      } finally {
        this.removeAttribute('data-loading');
      }
    }

    /**
     * Judge.me's markup into ours.
     *
     * Only a handful of their selectors are read, and anything that doesn't
     * match is skipped rather than guessed at — a review missing a body is
     * dropped, not rendered blank.
     */
    parse(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      return Array.from(doc.querySelectorAll('.jdgm-rev')).map((source) => {
        const text = (selector) => {
          const node = source.querySelector(selector);
          return node ? node.textContent.trim() : '';
        };

        const item = document.createElement('li');
        item.className = 'reviews__item';

        const name = text('.jdgm-rev__author');
        const rating = Number(
          (source.querySelector('.jdgm-rev__rating') || {}).dataset?.score || 0
        );
        const stamp = source.querySelector('time');

        const who = document.createElement('div');
        who.className = 'reviews__who';
        who.appendChild(this.span('reviews__avatar', name.charAt(0)));
        who.appendChild(this.span('reviews__name', name));
        if (source.querySelector('.jdgm-rev__buyer-badge')) {
          who.appendChild(this.span('reviews__verified', this.dataset.labelVerified));
        }

        const body = document.createElement('div');
        body.className = 'reviews__body';

        const meta = document.createElement('div');
        meta.className = 'reviews__meta';
        meta.appendChild(this.span('reviews__stars', '★'.repeat(rating) + '☆'.repeat(5 - rating)));
        if (stamp) {
          const time = document.createElement('time');
          time.className = 'reviews__date';
          time.dateTime = stamp.getAttribute('datetime') || '';
          time.textContent = this.date(stamp.getAttribute('datetime'));
          meta.appendChild(time);
        }
        body.appendChild(meta);

        const title = text('.jdgm-rev__title');
        if (title) body.appendChild(this.para('reviews__title', title));

        const prose = source.querySelector('.jdgm-rev__body');
        if (prose) {
          const wrap = document.createElement('div');
          wrap.className = 'reviews__text rte';
          this.clean(prose, wrap);
          body.appendChild(wrap);
        }

        const photos = this.photos(source, name);
        if (photos) body.appendChild(photos);

        item.append(who, body);
        return item;
      });
    }

    /**
     * Judge.me's review photos into this section's own markup.
     *
     * ⚠️ Their thumbnail <img> carries the URL on `data-src`, NOT `src` — the
     * widget script they ship populates it lazily, and this theme deliberately
     * does not load that script. Reading `src` returns nothing and the photos
     * silently never appear, which is exactly how they went missing here.
     *
     * The full size comes off the wrapping link (`href`, with `data-mfp-src` as
     * the fallback); both are the same file at width=1024.
     *
     * Only http(s) URLs are accepted. This is third-party markup arriving at
     * runtime and being written into an attribute the browser will fetch, so
     * the scheme is checked rather than trusted — the same instinct as putting
     * review bodies in through textContent.
     */
    photos(source, name) {
      const links = Array.from(source.querySelectorAll('.jdgm-rev__pic-link'));
      if (!links.length) return null;

      const safe = (url) => {
        if (!url) return '';
        try {
          return /^https?:$/.test(new URL(url, location.href).protocol) ? url : '';
        } catch {
          return '';
        }
      };

      const list = document.createElement('ul');
      list.className = 'reviews__photos';
      list.setAttribute('role', 'list');
      list.setAttribute('data-lightbox', '');

      for (const link of links) {
        const img = link.querySelector('img');
        const thumb = safe(img && (img.getAttribute('data-src') || img.getAttribute('src')));
        const full = safe(link.getAttribute('href') || link.getAttribute('data-mfp-src')) || thumb;
        if (!thumb) continue;

        const cell = document.createElement('li');
        cell.setAttribute('data-slide', '');
        cell.setAttribute('data-zoom-src', full);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reviews__photo-button';
        button.setAttribute('data-zoom-open', '');
        button.setAttribute(
          'aria-label',
          (this.dataset.labelPhoto || '').replace('NAME_', name)
        );

        const shot = document.createElement('img');
        shot.className = 'reviews__photo';
        shot.src = thumb;
        shot.alt = '';
        shot.loading = 'lazy';
        shot.width = 80;
        shot.height = 80;

        button.appendChild(shot);
        cell.appendChild(button);
        list.appendChild(cell);
      }

      return list.children.length ? list : null;
    }

    /**
     * Copies a review body across as text, one paragraph per source paragraph.
     *
     * Deliberately not innerHTML: this is third-party markup arriving at
     * runtime, and nothing in a review needs to be anything but prose. Taking
     * textContent removes the injection surface completely rather than trying
     * to sanitise it.
     */
    clean(source, target) {
      const blocks = source.querySelectorAll('p');
      const parts = blocks.length ? Array.from(blocks) : [source];

      parts.forEach((part) => {
        const line = part.textContent.trim();
        if (line) target.appendChild(this.para('', line));
      });
    }

    span(className, text) {
      const node = document.createElement('span');
      if (className) node.className = className;
      node.textContent = text;
      return node;
    }

    para(className, text) {
      const node = document.createElement('p');
      if (className) node.className = className;
      node.textContent = text;
      return node;
    }

    date(value) {
      if (!value) return '';
      const parsed = new Date(value);
      if (isNaN(parsed)) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return pad(parsed.getMonth() + 1) + '/' + pad(parsed.getDate()) + '/' + String(parsed.getFullYear()).slice(2);
    }

    /**
     * Up to five numbers, windowed around the current page — the shape Sitka's
     * control has, and the only one that survives a product with 102 pages.
     */
    render() {
      const span = Math.min(5, this.pages);
      let start = Math.max(1, this.page - 2);
      if (start + span - 1 > this.pages) start = this.pages - span + 1;

      const nodes = [this.arrow('prev', this.page - 1, this.page === 1)];

      for (let n = start; n < start + span; n += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reviews__page';
        button.dataset.page = n;
        // No aria-label: the button's text is the page number, and the nav
        // around it is already labelled. A label here would just repeat it.
        button.textContent = n;
        if (n === this.page) button.setAttribute('aria-current', 'page');
        nodes.push(button);
      }

      nodes.push(this.arrow('next', this.page + 1, this.page === this.pages));

      this.nav.replaceChildren(...nodes);
      this.nav.hidden = false;
    }

    arrow(direction, page, disabled) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'reviews__page reviews__page--' + direction;
      button.dataset.page = page;
      button.disabled = disabled;
      button.setAttribute(
        'aria-label',
        direction === 'prev' ? this.dataset.labelPrev : this.dataset.labelNext
      );

      const icon = document.createElement('span');
      icon.className = 'reviews__page-icon';
      icon.setAttribute('aria-hidden', 'true');
      if (this.caret) icon.appendChild(this.caret.content.cloneNode(true));
      button.appendChild(icon);
      return button;
    }

    /** The endpoint is not ours; if it stops answering, say so once and stop. */
    fail() {
      this.nav.replaceChildren(this.para('reviews__error', this.dataset.labelError));
    }
  }

  customElements.define('product-reviews', ProductReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  /**
   * Swaps a poster-and-play-button overlay for the playing video.
   *
   * The overlay ships `hidden` and is unhidden here, so a browser that never
   * runs this gets the plain <video> with its native poster and controls —
   * rather than a play button sitting over a video it cannot start.
   */
  class ProductVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.overlay = this.querySelector('[data-pv-play]');
      if (!this.video || !this.overlay) return;

      this.overlay.hidden = false;
      this.overlay.addEventListener('click', this.onPlay);

      // Native controls can pause it, and the overlay must not come back when
      // they do — it is an entry point, not a pause state.
      this.video.addEventListener('play', this.onStarted, { once: true });
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.onPlay);
    }

    onPlay = () => {
      /**
       * `preload="none"` means there is nothing buffered yet, so play() returns
       * a promise that can reject — autoplay policy, or a source that will not
       * load. Only retire the overlay once it actually resolves, otherwise a
       * failed play leaves a black frame and no way back.
       */
      const started = this.video.play();

      if (started && typeof started.catch === 'function') {
        started.catch(() => {
          this.overlay.hidden = false;
        });
      }

      this.overlay.hidden = true;
    };

    onStarted = () => {
      this.overlay.hidden = true;
    };
  }

  customElements.define('product-video', ProductVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class PdpProduct extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      if (!data) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch {
        return;
      }

      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.skuEl = this.querySelector('[data-sku]');

      // The value's own row, so a variant with no SKU takes the "SKU" label
      // with it rather than leaving a labelled empty cell in the list.
      this.skuRow = this.querySelector('[data-sku-row]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.atc = this.querySelector('[data-atc]');

      // Fit notice. Absent on every product that has not been given one, so all
      // of this stays null and the toggle below no-ops.
      this.notice = this.querySelector('[data-variant-notice]');
      this.noticeValues = [];
      if (this.notice) {
        try {
          this.noticeValues = JSON.parse(this.notice.dataset.variantNoticeValues);
        } catch {
          this.notice = null;
        }
      }

      // Low-stock line. Rendered whenever the feature is on, hidden until a
      // variant qualifies, so both handles are either present or both null.
      this.lowStock = this.querySelector('[data-low-stock]');
      this.lowStockText = this.querySelector('[data-low-stock-text]');

      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      const input = event.target;
      if (!input.matches('.pdp-options__input')) return;

      // Radios are rendered in option order, so the checked values line up with
      // each variant's `options` array positionally.
      const chosen = Array.from(
        this.querySelectorAll('.pdp-options__input:checked')
      ).map((radio) => radio.value);

      // Echo the chosen value back into "Colour: black".
      const label = this.querySelector(
        `[data-option-value="${input.dataset.optionPosition}"]`
      );
      if (label) label.textContent = input.value;

      // Driven by the chosen option values, not the resolved variant: a size
      // that has no matching variant still needs the notice to be right.
      if (this.notice) {
        this.notice.hidden = !chosen.some((value) =>
          this.noticeValues.includes(value)
        );
      }

      const variant = this.variants.find(
        (candidate) =>
          candidate.options.length === chosen.length &&
          candidate.options.every((option, i) => option === chosen[i])
      );

      if (variant) {
        this.update(variant);
      } else {
        // A combination that doesn't exist at all, e.g. a colour that was never
        // made in the chosen size.
        this.setButton(false, this.atc?.dataset.labelUnavailable);
        if (this.lowStock) this.lowStock.hidden = true;
      }
    };

    update(variant) {
      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;

      if (this.compareEl) {
        this.compareEl.textContent = variant.compareAt || '';
        this.compareEl.hidden = !variant.compareAt;
      }

      if (this.skuEl) {
        this.skuEl.textContent = variant.sku || '';
        (this.skuRow || this.skuEl).hidden = !variant.sku;
      }

      // `stock` is a number only for variants at or below the threshold; the
      // Liquid side already applied the tracked/deny rules, so null means hide.
      if (this.lowStock) {
        const stock = variant.stock;
        this.lowStock.hidden = !stock;
        if (stock && this.lowStockText) {
          this.lowStockText.textContent = this.lowStock.dataset.lowStockTemplate.replace(
            '[count]',
            stock
          );
        }
      }

      this.setButton(
        variant.available,
        variant.available
          ? this.atc?.dataset.labelAdd
          : this.atc?.dataset.labelSoldOut
      );

      // Keep the URL shareable, but replace rather than push so tapping through
      // swatches doesn't bury the back button.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);

      document.dispatchEvent(
        new CustomEvent('pdp:variant-change', {
          detail: { variant, mediaId: variant.mediaId },
        })
      );
    }

    setButton(enabled, label) {
      if (!this.atc) return;
      this.atc.disabled = !enabled;

      // Into the label element, not the button — the button also holds the
      // loader dots, and textContent on it would delete them.
      const target = this.atc.querySelector('[data-atc-label]') || this.atc;
      if (label) target.textContent = label;
    }
  }

  customElements.define('pdp-product', PdpProduct);

  /**
   * The Add-to-cart button's busy animation, ported from Truewerk's PDP.
   *
   * Theirs is Motion One; this is the same shape in plain WAAPI, because the
   * theme carries no animation library and this is the only thing that would
   * need one. Their timings, kept exactly: 0.15s for each half of the swap, run
   * in sequence rather than together, and a 0.35s dot pulse staggered by a third
   * of itself and alternating forever.
   *
   * State is the button's own `aria-busy`, so anything can drive it — set the
   * attribute and the dots come in, remove it and the label comes back. That is
   * also the correct thing to announce, which is why it is a real ARIA
   * attribute rather than a data one.
   *
   * The reverse direction runs when the fetch below resolves and the drawer
   * reports itself open.
   */
  class PdpAtc extends HTMLElement {
    static DURATION = 150;
    static PULSE = 350;
    static SHIFT = 10;

    connectedCallback() {
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-atc-label]');
      this.loader = this.querySelector('.pdp__atc-loader');
      if (!this.button || !this.label || !this.loader) return;

      this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];

      if (this.button.form) {
        this.button.form.addEventListener('submit', this.onSubmit);
      }

      // Watching the attribute rather than acting on submit directly keeps the
      // trigger and the animation separable.
      this.observer = new MutationObserver(this.onAttribute);
      this.observer.observe(this.button, { attributeFilter: ['aria-busy'] });

      /**
       * Coming back to the page through the bfcache restores the DOM exactly as
       * it was left — including a button frozen mid-add, with its label gone.
       * Truewerk clear this on `pageshow` and it is not optional.
       */
      window.addEventListener('pageshow', this.reset);
    }

    disconnectedCallback() {
      if (this.button && this.button.form) {
        this.button.form.removeEventListener('submit', this.onSubmit);
      }
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('pageshow', this.reset);
      this.cancel();
    }

    /**
     * Adds without leaving the page, which is also what lets the animation run
     * its full cycle: the dots hold while the request is in flight and the
     * label rolls back as the drawer opens.
     *
     * Any failure falls through to the native POST, so the worst case is the
     * behaviour this button had before the drawer existed.
     */
    onSubmit = async (event) => {
      const form = this.button.form;
      if (!form) return;

      event.preventDefault();
      this.button.setAttribute('aria-busy', 'true');

      // Add-ons (the Kydex holster insert, the ballistic panel) are separate
      // line items, some with their own properties, which one FormData post
      // cannot carry. When
      // any are present the whole add goes as JSON, the product's own line
      // rebuilt from the form so it is the same line either way.
      const addonEls = Array.from(form.querySelectorAll('[data-cart-addon]'));
      const addons = addonEls.flatMap((el) => (typeof el.items === 'function' ? el.items() : []));
      // A quantity pack is the product's own line in another form, so it goes
      // in place of it rather than beside it — see `quantity-breaks`.
      const replaced = addonEls.some(
        (el) => typeof el.replacesLine === 'function' && el.replacesLine()
      );

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: addons.length
            ? { Accept: 'application/json', 'Content-Type': 'application/json' }
            : { Accept: 'application/json' },
          body: addons.length
            ? JSON.stringify({ items: replaced ? addons : [this.lineFrom(form), ...addons] })
            : new FormData(form),
        });
        if (!response.ok) throw new Error(response.status);
        await response.json();

        // The drawer owns re-rendering and opening itself; this only reports
        // that the cart moved, then waits for it so the label doesn't roll back
        // into a page where nothing has visibly happened yet.
        document.dispatchEvent(new CustomEvent('cart:changed'));
        await this.drawerOpened();
      } catch (error) {
        // With no add-ons the native POST is the same add, just with a page
        // load. With add-ons it would silently drop the insert, so the form
        // stays put and the add-on reports it instead.
        if (!addons.length) {
          form.submit();
          return;
        }
        form.dispatchEvent(new CustomEvent('cart:add-failed'));
      }

      this.button.removeAttribute('aria-busy');
    };

    /**
     * The form as one `/cart/add.js` line: id, quantity, selling plan and every
     * `properties[...]` field, named exactly as the FormData post names them.
     */
    lineFrom(form) {
      const data = new FormData(form);
      const line = { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 };
      if (data.get('selling_plan')) line.selling_plan = Number(data.get('selling_plan'));
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      if (Object.keys(properties).length) line.properties = properties;
      return line;
    }

    /**
     * Resolves when the drawer reports itself open, or after a second either
     * way — a theme with no drawer, or one whose script failed, must not leave
     * this button spinning forever.
     */
    drawerOpened() {
      return new Promise((resolve) => {
        const done = () => {
          clearTimeout(timer);
          document.removeEventListener('cart:opened', done);
          resolve();
        };

        const timer = setTimeout(done, 1000);
        document.addEventListener('cart:opened', done, { once: true });
      });
    }

    reset = () => {
      this.button.removeAttribute('aria-busy');
    };

    onAttribute = () => {
      const busy = this.button.getAttribute('aria-busy') === 'true';

      // The CSS handles both resting states here, and it can only do that while
      // no filled animation is holding the elements.
      if (this.reduceMotion.matches) {
        this.cancel();
        return;
      }

      this.cancel();
      if (busy) this.enter();
      else this.leave();
    };

    /** Label out and up, then dots up into its place, then the pulse. */
    enter() {
      const { DURATION, SHIFT } = PdpAtc;

      this.play(this.label, [
        { transform: 'translateY(0)', opacity: 1 },
        { transform: `translateY(-${SHIFT}px)`, opacity: 0 },
      ], 0);

      this.play(this.loader, [
        { transform: `translateY(${SHIFT}px)`, opacity: 0 },
        { transform: 'translateY(0)', opacity: 1 },
      ], DURATION);

      this.pulse();
    }

    /** The same swap the other way round. */
    leave() {
      const { DURATION, SHIFT } = PdpAtc;

      this.play(this.loader, [
        { transform: 'translateY(0)', opacity: 1 },
        { transform: `translateY(-${SHIFT}px)`, opacity: 0 },
      ], 0);

      this.play(this.label, [
        { transform: `translateY(${SHIFT}px)`, opacity: 0 },
        { transform: 'translateY(0)', opacity: 1 },
      ], DURATION);
    }

    /**
     * Each dot fades to a tenth and back, a third of the duration apart, which
     * reads as a wave rather than three lights blinking together.
     */
    pulse() {
      const { DURATION, PULSE } = PdpAtc;

      Array.from(this.loader.children).forEach((dot, index) => {
        this.animations.push(
          dot.animate([{ opacity: 1 }, { opacity: 0.1 }], {
            duration: PULSE,
            // Offset by the swap as well, so the wave starts as the dots land
            // rather than part-way through their arrival.
            delay: DURATION + index * (PULSE / 3),
            direction: 'alternate',
            iterations: Infinity,
            easing: 'ease',
          })
        );
      });
    }

    play(element, keyframes, delay) {
      this.animations.push(
        element.animate(keyframes, {
          duration: PdpAtc.DURATION,
          delay: delay,
          easing: 'ease',
          /**
           * `both`, not `forwards`. Forwards alone holds the end state but says
           * nothing about the delay before the animation starts, so the second
           * half of a swap sits at its CSS resting state for the first 150ms —
           * on the way back that put the label at full opacity while the dots
           * were still leaving, and both were on screen at once. The backwards
           * half pins it to its first keyframe until its turn comes.
           */
          fill: 'both',
        })
      );
    }

    cancel() {
      this.animations.forEach((animation) => animation.cancel());
      this.animations = [];
    }
  }

  customElements.define('pdp-atc', PdpAtc);

  } catch(e) { console.error(e); }
})();
})();
